<script lang="ts">
    import { onMount } from "svelte";

    import { emoteGraphicCache, emoteSoundCache } from "../store/cache";

    import type { EmoteType } from "../types/emoteType";
    import { playSound } from "../misc/audio";
    import { fetchAssetAsBase64 } from "../misc/base64";

    export let emote: EmoteType = "chungus";

    $: emoteSoundPath = `sounds/${emote}.wav`;
    $: emoteGraphicPathExt = emote === "hopon" ? "gif" : "png";
    $: emoteGraphicPath = `emotes/${emote}.${emoteGraphicPathExt}`;

    onMount(async () => {
        await updateCache();
        playEmoteSound();
    });

    const updateCache = async () => {
        if (!emoteGraphicCache.isCacheSet(emote)) {
            const emoteGraphicBase64 = await fetchAssetAsBase64(
                emoteGraphicPath
            );
            emoteGraphicCache.updateCache(emote, emoteGraphicBase64);
        }

        if (!emoteSoundCache.isCacheSet(emote)) {
            const emoteSoundBase64 = await fetchAssetAsBase64(emoteSoundPath);
            emoteSoundCache.updateCache(emote, emoteSoundBase64);
        }
    };

    const playEmoteSound = () => playSound($emoteSoundCache[emote]);
</script>

<img
    width="128"
    height="128"
    src={$emoteGraphicCache[emote]}
    alt={emote}
    on:click={() => playEmoteSound()}
/>
